(function(){
  if(!window.VeeValidate) return

  var ru = {
    "code": "ru",
    "messages": {
      "alpha": "Поле {_field_} может содержать только буквы",
      "alpha_dash": "Поле {_field_} может содержать только буквы, цифры и дефис",
      "alpha_num": "Поле {_field_} может содержать только буквы и цифры",
      "alpha_spaces": "Поле {_field_} может содержать только буквы и пробелы",
      "between": "Поле {_field_} должно быть между {min} и {max}",
      "confirmed": "Поле {_field_} не совпадает Подтверждение",
      "digits": "Поле {_field_} должно быть числовым и точно содержать {length} цифры",
      "dimensions": "Поле {_field_} должно быть {width} пикселей на {height} пикселей",
      "email": "Поле {_field_} должно быть действительным электронным адресом",
      "excluded": "Поле {_field_} должно быть допустимым значением",
      "ext": "Поле {_field_} должно быть действительным файлом. ({args})",
      "image": "Поле {_field_} должно быть изображением",
      "oneOf": "Поле {_field_} должно быть допустимым значением",
      "integer": "Поле {_field_} должно быть целым числом",
      "length": "Длина поля {_field_} должна быть {length}",
      "max": "Поле {_field_} не может быть более {length} символов",
      "max_value": "Поле {_field_} должно быть {max} или менее",
      "mimes": "Поле {_field_} должно иметь допустимый тип файла. ({args})",
      "min": "Поле {_field_} должно быть не менее {length} символов",
      "min_value": "Поле {_field_} должно быть {min} или больше",
      "numeric": "Поле {_field_} должно быть числом",
      "regex": "Поле {_field_} имеет ошибочный формат",
      "required": "Поле {_field_} обязательно для заполнения",
      "required_if": "Поле {_field_} обязательно для заполнения",
      "size": "Поле {_field_} должно быть меньше, чем {size}KB"
    }
  };

  VeeValidate.localize('ru', ru);
})();